import axios from "axios";
import { maintenanceExternal } from "../contexts/MaintenanceContext";

export function createAxiosInstance(token: string) {
  const instance = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // 🔥 GLOBAL MAINTENANCE CHECK
  instance.interceptors.response.use(
    (response) => {
      // Backend returns maintenance at TOP LEVEL (not inside data)
      if (response.data?.maintenance) {
        maintenanceExternal.setMode(true);
        maintenanceExternal.setMessage(
          response.data.global_announcement ?? "System is currently undergoing maintenance"
        );
      }

      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
}